export class FundAccount {
  id: number = null;
  sourceType: number = null;
  sourceId: string = null;
  bank: string = null;
  branch: string = null;
  account: string = null;
  fundId: string = null;
  isAccountSettlement: boolean = null;
}
